import * as React from "react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Link } from "@/components/common/Link";
const galleryImages = [{
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-Album-Cover-AAOM-scaled.png?v=fwhqzha0zcm",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-Album-Cover-AAOM-scaled.png?v=t206xm755w-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-Album-Cover-AAOM-scaled.png?v=im2rqsz4hio-wvc-sizes",
  alt: "Neon Echoes Album Cover",
  caption: "AN AUDIENCE OF MOUNTAINS",
  credits: "Music - Lyrics - Mixing - Mastering (tracks 8-9) - Arranging - Recording - Performance: Guitars, Synth, Charango, Vocals, Tin Whistle, Percussion, Melodica, Kalimba",
  link: "https://old-water.ffm.to/anaudienceofmountains"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Mountain-Edits-Cover-FINAL-scaled.png?v=5ejr4vskook",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Mountain-Edits-Cover-FINAL-scaled.png?v=ohb8a71ex2i-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Mountain-Edits-Cover-FINAL-scaled.png?v=dg3ocmk6y5b-wvc-sizes",
  alt: "Silent Void Album Cover",
  caption: "Mountain Edits",
  credits: "Mastering - Music - Lyrics - Mixing - Arranging - Recording - Performance: Guitars, Synth, Charango, Vocals, Tin Whistle, Percussion, Melodica, Kalimba",
  link: "https://old-water.ffm.to/mountainedits"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=sjs68mu8ft",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=1xd5thgmjk2-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Front-Cover-website-temp.jpg?v=so00th1ivy-wvc-sizes",
  alt: "Kinetic Pulse Album Cover",
  caption: "The New Invention",
  credits: "Music - Lyrics - Arranging - Recording - Performance: Guitars, Bass, Mandolin, Vocals, Piano, Percussion",
  link: "https://emubands.ffm.to/thenewinvention"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/FINAL-Portada-scaled.png?v=wjoj0qnbzop",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/FINAL-Portada-scaled.png?v=7uiha95usr-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/FINAL-Portada-scaled.png?v=kq6e2wrety-wvc-sizes",
  alt: "Ether Dreams Album Cover",
  caption: "Aguanta",
  credits: "Mastering - Music - Lyrics - Mixing - Recording - Performance: Guitars, Vocals, Tin Whistle, Tongue Drum",
  link: "https://old-water.ffm.to/aguantafeatselvamonte"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Cover-FINAL-scaled.png?v=bc31fkf18h",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Cover-FINAL-scaled.png?v=ivta7wah0m8-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Cover-FINAL-scaled.png?v=eipb9vp3ub-wvc-sizes",
  alt: "Digital Dust Album Cover",
  caption: "Wayside Treasures",
  credits: "Music - Mixing - Mastering - Arranging - Recording - Performance: Guitars",
  link: "https://old-water.ffm.to/waysidetreasures"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=e85f6ibuwih",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=t3uoxpk8ays-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/OW-Jam-Tracks-Volume-I-Final-Cover-Art-scaled.png?v=4qmbev1048l-wvc-sizes",
  alt: "Sonic Bloom Album Cover",
  caption: "Volume I",
  credits: "Music - Arranging - Recording - Performance: Guitars, Bass, Mandolin, Vocals, Piano, Percussion",
  link: "https://open.spotify.com/album/09puHGfkLZeMwMQAwcPoav?si=6YMVmC5cT4mnMSDjRI0U5g"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/jam-track-II-cover-scaled.png?v=8nz7nx0cfej",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/jam-track-II-cover-scaled.png?v=fhvfuv53veu-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/jam-track-II-cover-scaled.png?v=10em4wezzty-wvc-sizes",
  alt: "Velvet Frequency Album Cover",
  caption: "Volume II",
  credits: "Music - Mixing - Arranging - Recording - Performance: Guitars, Synth, Charango, Vocals, Tin Whistle, Percussion, Melodica, Kalimba",
  link: "https://owjamtracks.ffm.to/volumeii"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=bmodf191i44",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=ppx5rcztnsj-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Album-Cover.png?v=66r5j7n580c-wvc-sizes",
  alt: "Orbital Path Album Cover",
  caption: "Smithfield: The Soundtrack",
  credits: "Composition - Mixing - Mastering - Performance (Guitar, Charango, Shaker, Drum)",
  link: "https://oldwater.ffm.to/smithfield-thesoundtrack"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-cover-ep1.png?v=g8gu8arco3b",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-cover-ep1.png?v=9gbfvaczpi-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Final-cover-ep1.png?v=uips8ncze2k-wvc-sizes",
  alt: "Neon Horizon Album Cover",
  caption: "Dirty Selfie",
  credits: "Mastering - Mixing - Composition - Editing - Performance: Guitars, Bass",
  link: "https://dirtyselfie.ffm.to/dirtyselfie"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/277363841_5589199297761283_1126073759712198043_n.jpg-wvc-sizes",
  alt: "The Future is behind us Album Cover",
  caption: "The Future is behind us",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/1MJuWQASjalAll5aMpn0CO?si=yFUwj3GMRDyilLckFLUXew&nd=1&dlsi=111cfc30e16341cd"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/324626946_563566725338492_4071046814754388836_n.jpg-wvc-sizes",
  alt: "Up To Our Necks Album Cover",
  caption: "Up To Our Necks",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/46ssCtzJmw8Lyp6nzFJnPZ?si=voPyUVUqRQuTMazNbx0eKg&nd=1&dlsi=6b6bf8f07ddb40c2"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2024-02-05-at-19.59.52.png-wvc-sizes",
  alt: "Artefacts Album Cover",
  caption: "Artefacts",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/76iCtRZi4mRsxMQhFciRFI?si=idWzmJHhSlydVVVOYc5iaA&nd=1&dlsi=25b04ad1f6f84f57"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/TPIDA-Square-Cover.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/TPIDA-Square-Cover.jpg-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/TPIDA-Square-Cover.jpg-wvc-sizes",
  alt: "The Past Is dead ahead Album Cover",
  caption: "The Past Is dead ahead",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/4m2YpfwNtaPr13IH6DRYvN?si=musl6U1gSF2oYn_cWpSPSw&nd=1&dlsi=d09a600dface42af"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2025-11-30-at-16.35.32.jpeg-wvc-sizes",
  alt: "Ones & Zeros Album Cover",
  caption: "Ones & Zeros",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/1xaQKi6HFiglEiWFQyVNLw?si=GDaEOMB_S5iEoUeqN0IF5g&nd=1&dlsi=f9982957dcb9454c"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Screenshot-2025-11-20-at-13.40.00.png-wvc-sizes",
  alt: "Up to our necks - Radio Edit Album Cover",
  caption: "Up to our necks - Radio Edit",
  credits: "Songwriting - Performance: Guitar",
  link: "https://open.spotify.com/album/0nZ08GwFmeXt9SdGUc7G9J?si=0CVZ7cygRcq6EknZpo5wsw&nd=1&dlsi=8d261db815f14d5e"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/invisible_colours_cover.jpg-wvc-sizes",
  alt: "Invisible colours Album Cover",
  caption: "Invisible colours",
  credits: "Arranging - Performance: Guitar, Tenor Mandola",
  link: "https://open.spotify.com/album/6U0t6oX5J62A91dd6WkW11?si=wtee6fD-SuiAgo74lTovCw&nd=1&dlsi=500bf5bd03fe4079"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Ruth-Owens-EP-Cover.jpeg-wvc-sizes",
  alt: "As You Mean to Go On Album Cover",
  caption: "As You Mean to Go On",
  credits: "Arranging - Performance: Guitar, Mandolin",
  link: "https://soundcloud.com/ruthowensmusic/sets/asyoumeantogoon"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Myoho-youtube.jpg-wvc-sizes",
  alt: "Myoho Valley Youtube Album Cover",
  caption: "Myoho Valley Youtube",
  credits: "Music - Production - Recording - Video Editing",
  link: "https://youtube.com/@myohovalleyyt?si=p3UK18I7RlLUN6S4"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/norris-brown-website.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/norris-brown-website.png-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/norris-brown-website.png-wvc-sizes",
  alt: "Norris-Brown Album Cover",
  caption: "Norris-Brown",
  credits: "Mix & Master for ´Turn Out the Light´",
  link: "https://www.norris-brown.com/home"
}, {
  src: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png",
  srcset: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png-wvc-srcset",
  sizes: "https://skilled-urchin.10web.cloud/wp-content/uploads/2026/05/Soundtrack-Cover-scaled.png-wvc-sizes",
  alt: "Coffee & Milk: Soundtrack Album Cover",
  caption: "Coffee & Milk: Soundtrack",
  credits: "Composition - Mixing - Mastering - Recording - Performance: Guitar, Virtual Strings",
  link: "https://example.com/infinite-loop"
}];
export default function StaticAlbumGallery() {
  return <section data-section-id="256222" id="static-album-gallery" className="bg-background text-foreground py-8 md:py-12 border-t border-border">
      <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-7xl">
        <h2 className="font-bold font-serif uppercase tracking-tighter mb-8 !text-3xl md:mb-12">VIDEO WORK</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3 md:gap-5">
          {galleryImages.map((image, i) => <Link key={i} to={image.link} newTab data-index={i} className="group relative overflow-hidden rounded-md shadow-md bg-card">
              <AspectRatio ratio={1 / 1}>
                <img src={image.src} data-wvc-srcset={image.srcset} data-wvc-sizes={image.sizes} alt={image.alt} loading="lazy" className="object-cover w-full h-full transition-transform duration-700 ease-out group-hover:scale-110" />
                <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center p-4">
                  <span className="text-primary font-default text-sm md:text-base font-semibold text-center tracking-tight uppercase">
                    {image.caption}
                  </span>
                  {image.credits && <p className="text-primary/80 font-default text-xs text-center mt-1">
                      {image.credits}
                    </p>}
                </div>
                <div className="absolute inset-0 bg-gradient-to-t from-secondary/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none mix-blend-overlay" />
              </AspectRatio>
            </Link>)}
        </div>
      </div>
    </section>;
}